import type { PulseProfileOption } from "@/api/pulse";

interface Props {
  profiles: PulseProfileOption[];
  activeSlug?: string;
  onChange?: (slug: string) => void;
}

function profileLabel(profile: PulseProfileOption): string {
  if (profile.slug === "radaria") return "IA";
  if (profile.slug === "radarmkt") return "Publicidad";
  return profile.name;
}

export default function PulseProfileSwitch({ profiles, activeSlug, onChange }: Props) {
  if (profiles.length <= 1 || !onChange) return null;

  return (
    <nav
      aria-label="Selector de perfil"
      className="pulse-profile-switch flex items-center gap-4 max-sm:gap-2"
    >
      {profiles.map((profile) => {
        const isActive = profile.slug === activeSlug;
        return (
          <button
            key={profile.slug}
            type="button"
            className="pulse-section-tab border-0 bg-transparent p-0 text-left text-[#003f2a] focus-visible:outline-none"
            aria-pressed={isActive}
            onClick={() => onChange(profile.slug)}
          >
            <span className="relative inline-flex flex-col pb-[3px]">
              <span
                className={`font-['IberPangea_VAR','IberPangea VAR',sans-serif] text-[16px] font-bold leading-normal ${
                  isActive ? "opacity-100" : "opacity-65 hover:opacity-90"
                }`}
              >
                {profileLabel(profile)}
              </span>
              <span
                className={`pulse-section-tab__line ${
                  isActive
                    ? "pulse-section-tab__line--static-on"
                    : "pulse-section-tab__line--static-off"
                }`}
              />
            </span>
          </button>
        );
      })}
    </nav>
  );
}
